import apiClient from "../api/apiClient";
import ENDPOINTS from "../api/endPoint";

export const fetchEscalationTatConfigs = () =>
  apiClient(ENDPOINTS.DISPUTE_ESCALATION_CONFIG.LIST, { method: "GET" });

export const upsertEscalationTatConfig = (payload) =>
  apiClient(ENDPOINTS.DISPUTE_ESCALATION_CONFIG.UPSERT, {
    method: "POST",
    body: payload,
  });

export const deleteEscalationTatConfig = (id) =>
  apiClient(ENDPOINTS.DISPUTE_ESCALATION_CONFIG.DELETE(id), {
    method: "DELETE",
  });

export const fetchEscalationSettings = () =>
  apiClient(ENDPOINTS.DISPUTE_ESCALATION_CONFIG.SETTINGS, { method: "GET" });

export const fetchDisputeCategories = () =>
  apiClient(ENDPOINTS.DISPUTE_CATEGORIES, { method: "GET" });
